export default {
  name: 'custom',
  components: {
    'top-header': () => import('@/views/common/header/index.vue'),
    'bottom': () => import('@/views/common/bottom/index.vue')
  },
  data () {
    return {
    }
  },
  methods: {
  },
  // 计算属性
  computed: {
    getTabs () {
      let tabs = ''
      let count = 0
      for (let key in this.$store.state.tabs) {
        if (count < 1) {
          tabs += this.$store.state.tabs[key]
        } else {
          tabs += ',' + this.$store.state.tabs[key]
        }
        count++
      }
      return tabs
    }
  },
  created () {
  },
  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/views/custom/script.js